<div class="app-container">
  @if (productMovePack) {
    <page-header
      [icon]="'far-exchange'"
      [title]="'product-move-pack.' + productMovePack.type.id | translate"
      [appendNoTranslationTitlePart]="productMovePack.number.toString()"
    >
      <ng-container class="header-button">
        <div class="d-flex align-items-center flex-gap-5">
          @if (productMovePack.url?.length && productMovePack.pdfWOPricesUrl?.length) {
            <btn
              id="dropdownPdf"
              [classes]="['btn-third', 'float-right', 'me-1', 'dropdown-toggle']"
              [icon]="'far-file-pdf'"
              [label]="'download.pdf' | translate"
              [title]="('select' | translate) + ' ' + ('type' | translate | lowercase)"
              [dataCyAttribute]="'download-pdf'"
              data-bs-toggle="dropdown"
            >
            </btn>
            <div class="dropdown-menu margin-right-150" aria-labelledby="dropdownPdf">
              <button class="dropdown-item small" type="button" (click)="downloadPdf('issueSlip')">
                {{
                  productMovePack.type?.id === 'out'
                    ? ('download.pdf-issueSlip.out' | translate)
                    : productMovePack.type?.id === 'in'
                      ? ('download.pdf-issueSlip.in' | translate)
                      : productMovePack.type?.id === 'transfer'
                        ? ('download.pdf-issueSlip.transfer' | translate)
                        : productMovePack.type?.id === 'reservation'
                          ? ('download.pdf-issueSlip.reservation' | translate)
                          : ''
                }}
              </button>
              <button class="dropdown-item small" type="button" (click)="downloadPdf('deliveryNote')">
                {{
                  productMovePack.type?.id === 'reservation'
                    ? ('download.pdf-reservation' | translate)
                    : productMovePack.type?.id === 'in'
                      ? ('download.pdf-in' | translate)
                      : productMovePack.type?.id === 'transfer'
                        ? ('download.pdf-transfer' | translate)
                        : ('download.pdf-deliveryNote' | translate)
                }}
              </button>
            </div>
            <btn
              id="dropdownExcel"
              [classes]="['btn-third', 'float-right', 'me-1', 'dropdown-toggle']"
              [icon]="'far-file-excel'"
              [label]="'download.excel' | translate"
              [title]="('select' | translate) + ' ' + ('type' | translate | lowercase)"
              [dataCyAttribute]="'download-excel'"
              data-bs-toggle="dropdown"
            >
            </btn>
            <div class="dropdown-menu margin-right-150" aria-labelledby="dropdownExcel">
              <button class="dropdown-item small" type="button" (click)="downloadExcel('serialNumbers')">
                {{ 'download.excel-serialNumbers' | translate }}
              </button>
            </div>
            @if (productMovePack?.moves?.length > 0) {
              <btn
                [label]="isPrintingEANs ? 'back' : 'product.tab.barcode'"
                [title]="isPrintingEANs ? ('back' | translate) : ('product.tab.barcode' | translate)"
                [icon]="isPrintingEANs ? 'far-list' : 'far-sticky-note'"
                [classes]="['btn-third', 'float-right', 'me-2']"
                (onEvent)="isPrintingEANs = !isPrintingEANs"
              ></btn>
            }
          }
          @if (canDownloadOrionEdi()) {
            <btn
              [classes]="['btn-third', 'float-right', 'me-1']"
              [icon]="'far-file-code'"
              [label]="'download.orion-edi' | translate"
              [title]="'download.orion-edi' | translate"
              [btnDisabled]="isDownloadingOrionEdi"
              [isLoading]="isDownloadingOrionEdi"
              [dataCyAttribute]="'download-orion-edi'"
              (onEvent)="downloadOrionEdi()"
            ></btn>
          }
          @if (productMovePack.deletable && userCanDeleteProductMoves) {
            <btn
              [btnType]="'button'"
              [classes]="['btn-first-red', 'float-right', 'me-2']"
              [btnDisabled]="loading"
              [label]="'delete'"
              [icon]="'far-trash-alt'"
              [dataCyAttribute]="'delete-product'"
              (onEvent)="deleteProductMovePack()"
            ></btn>
          }
        </div>
      </ng-container>
      <ng-container class="back-button">
        <btn
          [label]="'back'"
          [title]="'back' | translate"
          [isBackButton]="true"
          [classes]="['btn-third', 'float-right', 'me-2']"
          [icon]="'far-arrow-left'"
          (onEvent)="goBack()"
        ></btn>
      </ng-container>
    </page-header>
  }
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  @if (!!productMovePack && isPrintingEANs) {
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <!--            <barcode-list-print-array [operations]="operations"></barcode-list-print-array>-->
          <print-code #printCodeComponent [productMovePack]="productMovePack" [doRecalculateArray]="false"></print-code>
        </div>
      </div>
    </div>
  }
  @if (!!productMovePack && !isPrintingEANs) {
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4 ps-0">
          <div class="card responsiveInfoCardProductMovePack">
            <div>
              <h3 class="card-title mb-3">
                {{ 'info' | translate }}
              </h3>
            </div>
            <div>
              <table class="table m-0">
                <tbody class="no-hover">
                  <tr>
                    <td class="ps-0 card-subheading">
                      {{ 'dateCreated' | translate }}
                    </td>
                    <td class="text-end">
                      {{ productMovePack.dateCreated | strToDate | date: 'dd.MM.yyyy HH:mm' }}
                    </td>
                  </tr>
                  @if (productMovePack.order && productMovePack.order.checkout) {
                    <tr>
                      <td class="ps-0 card-subheading">
                        {{ 'checkout' | translate }}
                      </td>
                      <td class="text-end">
                        <a class="link" [routerLink]="['/checkout', productMovePack.order.checkout.id]">{{
                          productMovePack.order.checkout ? productMovePack.order.checkout.name : ''
                        }}</a>
                      </td>
                    </tr>
                  }
                  <tr>
                    <td class="ps-0 card-subheading">
                      {{ 'createdBy' | translate }}
                    </td>
                    <td class="text-end">
                      @if (productMovePack.createdBy) {
                        <a class="link" [routerLink]="['/user', productMovePack.createdBy.id]">{{
                          productMovePack.createdBy.firstName +
                            ' ' +
                            productMovePack.createdBy.lastName +
                            ' (' +
                            productMovePack.createdBy.email +
                            ')'
                        }}</a>
                      }
                    </td>
                  </tr>
                  @if (productMovePack.depotFrom?.id) {
                    <tr>
                      <td class="ps-0 card-subheading">{{ 'depotFrom' | translate }}</td>
                      <td class="text-end">
                        <a class="link" [routerLink]="['/depot', productMovePack.depotFrom.id]">{{
                          productMovePack.depotFrom.name
                        }}</a>
                      </td>
                    </tr>
                  }
                  @if (productMovePack.depotTo?.id) {
                    <tr>
                      <td class="ps-0 card-subheading">{{ 'depotTo' | translate }}</td>
                      <td class="text-end">
                        <a class="link" [routerLink]="['/depot', productMovePack.depotTo.id]">{{
                          productMovePack.depotTo.name
                        }}</a>
                      </td>
                    </tr>
                  }
                  @if (productMovePack.order?.vs > 0) {
                    <tr>
                      <td class="ps-0 card-subheading">{{ 'vs' | translate }}</td>
                      <td class="text-end">{{ productMovePack.order.vs ? productMovePack.order.vs : '' }}</td>
                    </tr>
                  }
                  @if (productMovePack.order?.id) {
                    <tr>
                      <td class="ps-0 card-subheading">
                        {{ 'order' | translate }}
                      </td>
                      <td class="flex-gap-5 justify-content-end text-end">
                        <app-order-preview
                          [order]="productMovePack.order"
                          [isOnProductMovePackPage]="true"
                        ></app-order-preview>
                      </td>
                    </tr>
                  }
                  @if (productMovePack?.purchaseOrder?.id) {
                    <tr>
                      <td class="ps-0 card-subheading">
                        {{ 'product-move-pack.purchase-order' | translate }}
                      </td>
                      <td class="flex-gap-5 justify-content-end text-end">
                        <a class="link" [routerLink]="['/purchase-order', productMovePack.purchaseOrder.id]">
                          {{ productMovePack.purchaseOrder?.number }}
                        </a>
                      </td>
                    </tr>
                  }
                  @for (move of productMovePack.moves | slice: 0 : 1; track move) {
                    <tr>
                      <td class="ps-0 card-subheading text-nowrap">
                        {{ 'bill.quantity' | translate }} / {{ 'bill.amount' | translate }}
                      </td>
                      <td class="text-end">
                        <div class="flex-gap-10 flex-row-reverse">
                          <strong>{{ quantityItemsSum | number: '1.0-2' | replaceCommaToDot }}</strong>
                          <strong>/</strong>
                          <strong>{{ productMovePack.moves | listLength }}</strong>
                        </div>
                      </td>
                    </tr>
                  }
                  @if (productMovePack?.externalId) {
                    <tr>
                      <td class="ps-0 card-subheading">
                        {{ 'externalId' | translate }}
                      </td>
                      <td class="text-end">
                        {{ productMovePack.externalId }}
                      </td>
                    </tr>
                  }
                  <tr>
                    <td class="ps-0 card-subheading">
                      {{ 'externalReference' | translate }}
                    </td>
                    <td class="text-end">
                      {{ productMovePack.externalReference || '–' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="ps-0 card-subheading">
                      {{ 'tags' | translate }}
                    </td>
                    <td>
                      <div class="d-flex gap-1 justify-content-right">
                        <form-row-select-multiple
                          [ngClass]="'responsiveTagsInput'"
                          [options]="queryTagsOptions.data()"
                          [isTags]="true"
                          [(selectedValues)]="productMovePack.tags"
                          [dataCyAttribute]="'orders-tags-filter'"
                        ></form-row-select-multiple>
                        <btn
                          [label]="'save'"
                          [title]="'save' | translate"
                          [classes]="['btn-first']"
                          [icon]="'far-check'"
                          (click)="updateTags()"
                          [btnDisabled]="loading"
                          [isLoading]="loading"
                          [dataCyAttribute]="'create-depot'"
                        ></btn>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="ps-0 card-subheading align-top">
                      {{ 'note' | translate }}
                    </td>
                    <td>
                      <form-row-textarea
                        [label]="''"
                        [model]="productMovePack.note"
                        (modelChange)="productMovePack.note = $event"
                        [rows]="4"
                        [noMarginBottom]="true"
                        [dataCyAttribute]="'product-move-pack-note'"
                      ></form-row-textarea>
                      <div class="d-flex justify-content-end mt-2">
                        <btn
                          [label]="'save'"
                          [title]="'save' | translate"
                          [classes]="['btn-first']"
                          [icon]="'far-check'"
                          [btnDisabled]="loading || mutationUpdateNote.isPending() || !isNoteChanged()"
                          [isLoading]="mutationUpdateNote.isPending()"
                          [dataCyAttribute]="'product-move-pack-note-save'"
                          (onEvent)="updateNote()"
                        ></btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-8 pe-0">
          @if (productMovePack?.files?.length) {
            <div class="card">
              <div class="row col">
                <h3 class="card-title mb-3">
                  {{ 'files' | translate }}
                </h3>
              </div>
              <div>
                @for (f of productMovePack.files; track f) {
                  <div>
                    @if (f.mimeType?.includes('image/')) {
                      <i class="fa fa-file-image" title="Image"></i>
                    }
                    @if (
                      f.mimeType?.includes('text/') ||
                      f.mimeType?.includes('/msword') ||
                      f.mimeType?.includes('wordprocessingml')
                    ) {
                      <i class="fa fa-file-text" title="Text"></i>
                    }
                    @if (f.mimeType?.includes('application/pdf')) {
                      <i class="fa fa-file-pdf" title="Pdf"></i>
                    }
                    @if (f.mimeType?.includes('spreadsheet') || f.mimeType?.includes('ms-excel')) {
                      <i class="fa fa-file-excel" title="Excel"></i>
                    }
                    @if (unknownType(f.mimeType)) {
                      <i class="fa fa-file" title="File"></i>
                    }
                    <a class="link" href="{{ f.url }}" target="_blank"
                      >&ensp;{{ f.originalFilename || f.text || 'file' }}</a
                    >
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
      @if (productMovePack.moves?.length) {
        <div class="row">
          <div class="col-12 col-md-12 ps-0 pe-0">
            <div class="card">
              <div class="box box-default">
                <div class="box-body">
                  <div class="table-responsive">
                    <table class="table m-0" [photoGalleryGroup]="{ index: 1 }">
                      <thead>
                        <tr>
                          <th>{{ 'product.name' | translate }}</th>
                          <th>{{ 'product.code' | translate }}</th>
                          <th>{{ 'product.ean' | translate }}</th>
                          <th>{{ 'product.batch' | translate }}</th>
                          <th>{{ 'expiration' | translate }}</th>
                          <th>{{ 'position' | translate }}</th>
                          @if (
                            productMovePack.type.id === 'in' ||
                            (productMovePack.type.id === 'out' && hasOrderItems) ||
                            productMovePack.type.id === 'reservation'
                          ) {
                            <th>
                              {{ 'supplier' | translate }}
                            </th>
                          }
                          @if (
                            (productMovePack.type.id === 'out' && !hasOrderItems) ||
                            productMovePack.type.id === 'transfer'
                          ) {
                            <th>
                              {{ 'bill.vatrate' | translate }}
                            </th>
                          }
                          <th class="text-end">{{ 'purchasePrice' | translate }}</th>
                          @if (
                            (productMovePack.type.id === 'out' && hasOrderItems) ||
                            productMovePack.type.id === 'reservation'
                          ) {
                            <th class="text-end">
                              {{ 'sellPrice' | translate }}
                            </th>
                          }
                          <th class="text-end">{{ 'bill.qty' | translate }}</th>
                          <th class="text-end">
                            {{ hasOrderItems ? ('sellPrice.total' | translate) : ('purchasePrice.total' | translate) }}
                          </th>
                          @if (isAnyOfMovesDeletable) {
                            <th>&nbsp;</th>
                          }
                          @if (isRequiredSerialNumbers) {
                            <th>&nbsp;</th>
                          }
                        </tr>
                      </thead>
                      @for (move of productMovePack.moves; track move) {
                        <tbody>
                          <!--todo: move.orderItem // has Order todo returns-->
                          @if (move?.orderItem) {
                            <tr>
                              @if (move.orderItem.product?.id) {
                                <td class="ps-1 no-hover">
                                  <div class="d-flex flex-column">
                                    <div class="flex-gap-10 align-items-center">
                                      @if (move.orderItem.product.mainImage) {
                                        <div
                                          class="align-items-center"
                                          [photoGallery]="move.orderItem.product.mainImage?.url"
                                          [photoGalleryCaption]="
                                            move.orderItem.product.fullName +
                                            '<br>' +
                                            (move.orderItem.product.code
                                              ? ('product.code' | translate) + move.orderItem.product.code
                                              : '') +
                                            '<br>' +
                                            (move.orderItem.product.ean
                                              ? ('product.ean' | translate) + move.orderItem.product.ean
                                              : '')
                                          "
                                        >
                                          <div class="images-item">
                                            @if (
                                              !!move.orderItem.product.mainImage?.url?.length &&
                                              !!move.orderItem.product.mainImage?.thumbnails?.length
                                            ) {
                                              <img
                                                class="images-item-image"
                                                [src]="getThumbUrl(move.orderItem.product.mainImage)"
                                                [alt]="move.orderItem.product.fullName"
                                              />
                                            }
                                            @if (
                                              !move.orderItem.product.mainImage?.url?.length ||
                                              !move.orderItem.product.mainImage?.thumbnails?.length
                                            ) {
                                              <img
                                                class="images-item-image"
                                                [src]="'assets/img/no-image.png'"
                                                [alt]="move.productDepotTo.product.fullName"
                                              />
                                            }
                                          </div>
                                        </div>
                                      }
                                      <div class="flex-gap-5 align-items-center">
                                        <a class="link-bold" [routerLink]="['/product', move.orderItem.product.id]">{{
                                          move.orderItem.product.fullName
                                        }}</a>
                                        @if (
                                          move.orderItem.product.quantityUnavailable > 0 &&
                                          productMovePack.type.id === 'reservation'
                                        ) {
                                          <span
                                            class="badge bg-danger badge-unavail"
                                            title="{{ 'unavailables' | translate }}"
                                          >
                                            {{
                                              (move.orderItem.product.quantityUnavailable
                                                | number: '1.0-2'
                                                | replaceCommaToDot) +
                                                (move.orderItem.product &&
                                                move.orderItem.product.quantityUnavailable > 0
                                                  ? '/' +
                                                    (move.orderItem.product.quantityUnavailable
                                                      | number: '1.0-2'
                                                      | replaceCommaToDot)
                                                  : '')
                                            }}
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              }
                              @if (move.orderItem && !move.orderItem.product) {
                                <td class="no-hover">
                                  <strong>&nbsp;</strong>
                                </td>
                              }
                              <td class="no-hover text-nowrap">
                                {{ move.orderItem?.product?.code ?? '' }}
                              </td>
                              <td class="no-hover text-nowrap">
                                {{ move.orderItem?.product?.ean ?? '' }}
                              </td>
                              <td class="no-hover">
                                {{ move.productDepotFrom?.batch || move.productDepotTo?.batch || '' }}
                              </td>
                              <td class="no-hover">
                                {{
                                  move.productDepotFrom?.expirationDate?.length
                                    ? (move.productDepotFrom.expirationDate | fmtDate: 'dd.MM.yyyy')
                                    : move.productDepotTo?.expirationDate?.length
                                      ? (move.productDepotTo.expirationDate | fmtDate: 'dd.MM.yyyy')
                                      : ''
                                }}
                              </td>
                              <td class="no-hover">
                                {{
                                  move.productDepotFrom?.position?.length > 2
                                    ? move.productDepotFrom.position
                                    : move.productDepotTo?.position?.length > 2
                                      ? move.productDepotTo.position
                                      : ''
                                }}
                              </td>
                              <td class="no-hover">
                                {{ move.productDepotFrom?.supplier?.name || '' | translate }}
                              </td>
                              <td class="no-hover text-nowrap text-end">
                                {{ move.purchasePrice ?? 0 | formatPrice }}
                              </td>
                              @if (productMovePack.type.id === 'out' || productMovePack.type.id === 'reservation') {
                                <td class="no-hover text-nowrap text-end">
                                  {{ move.orderItem?.priceWithoutVat ?? 0 | formatPrice }}
                                </td>
                              }
                              <td class="no-hover text-end">{{ move.amount | number: '1.0-2' | replaceCommaToDot }}</td>
                              @if (productMovePack.type.id === 'in') {
                                <td class="no-hover text-nowrap text-end">
                                  {{ move.orderItem?.priceWithoutVat ?? 0 | formatPrice }}
                                </td>
                              }
                              @if (productMovePack.type.id !== 'in') {
                                <td class="no-hover text-nowrap text-end">
                                  {{
                                    (move.orderItem ? move.orderItem.priceWithoutVat * move.amount : 0) | formatPrice
                                  }}
                                </td>
                              }
                              <td>
                                @if (move.deletable && userCanDeleteProductMoves) {
                                  <btn
                                    [btnType]="'button'"
                                    [classes]="['btn-trash', 'btn-sm', 'float-right']"
                                    (onEvent)="deleteProductMove(move)"
                                    [icon]="'far-trash-alt'"
                                    [title]="'delete' | translate"
                                    data-cy="delete-row-category"
                                  ></btn>
                                }
                              </td>
                              @if (isRequiredSerialNumbers) {
                                <td>
                                  @if (move.product.requiredSerialNumbers) {
                                    <app-modal-serial-numbers
                                      #modalSerialNumbers
                                      [productMove]="move"
                                      (serialNumbersEdited)="updateProductMovePack()"
                                    >
                                    </app-modal-serial-numbers>
                                  }
                                </td>
                              }
                            </tr>
                          }
                          @if (move && !move.orderItem && !!move.productDepotTo && !move.productDepotFrom) {
                            <tr>
                              @if (move.productDepotTo?.product?.id) {
                                <td class="ps-1 no-hover">
                                  <div class="flex-gap-10 align-items-center" [photoGalleryGroup]="{ index: 2 }">
                                    <div
                                      [photoGallery]="move.productDepotTo.product.mainImage?.url"
                                      [photoGalleryCaption]="
                                        move.productDepotTo.product.fullName +
                                        '<br>' +
                                        (move.productDepotTo.product.code
                                          ? ('product.code' | translate) + move.productDepotTo.product.code
                                          : '') +
                                        '<br>' +
                                        (move.productDepotTo.product.ean
                                          ? ('product.ean' | translate) + move.productDepotTo.product.ean
                                          : '')
                                      "
                                    >
                                      <div class="images-item">
                                        @if (
                                          !!move.productDepotTo.product.mainImage?.url?.length &&
                                          !!move.productDepotTo.product.mainImage?.thumbnails?.length
                                        ) {
                                          <img
                                            class="images-item-image"
                                            [src]="getThumbUrl(move.productDepotTo.product.mainImage)"
                                            [alt]="move.productDepotTo.product.fullName"
                                          />
                                        }
                                        @if (
                                          !move.productDepotTo.product.mainImage?.url?.length ||
                                          !move.productDepotTo.product.mainImage?.thumbnails?.length
                                        ) {
                                          <img
                                            class="images-item-image"
                                            [src]="'assets/img/no-image.png'"
                                            [alt]="move.productDepotTo?.product?.fullName"
                                          />
                                        }
                                      </div>
                                    </div>
                                    <div>
                                      <div>
                                        <a
                                          class="link-bold"
                                          [routerLink]="['/product', move.productDepotTo.product.id]"
                                        >
                                          {{ move.productDepotTo.product.fullName }}
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              }
                              @if (move.productDepotTo && !move.productDepotTo.product) {
                                <td class="no-hover">
                                  <strong>&nbsp;</strong>
                                </td>
                              }
                              <td class="text-nowrap no-hover">
                                {{
                                  move.productDepotTo && move.productDepotTo.product
                                    ? move.productDepotTo.product.code
                                    : ''
                                }}
                              </td>
                              <td class="text-nowrap no-hover">
                                {{
                                  move.productDepotTo && move.productDepotTo.product
                                    ? move.productDepotTo.product.ean
                                    : ''
                                }}
                              </td>
                              <td class="text-nowrap no-hover">
                                {{ move.productDepotTo?.batch ?? '' }}
                              </td>
                              <td class="text-nowrap no-hover">
                                {{
                                  move.productDepotTo?.expirationDate?.length
                                    ? (move.productDepotTo.expirationDate | fmtDate: 'dd.MM.yyyy')
                                    : ''
                                }}
                              </td>
                              <td class="text-nowrap no-hover">
                                {{
                                  !!move.productDepotTo.position && move.productDepotTo.position.length > 2
                                    ? move.productDepotTo.position
                                    : ''
                                }}
                              </td>
                              <td class="no-hover">
                                {{ move.productDepotTo?.supplier?.name || '' | translate }}
                              </td>
                              <td class="text-nowrap no-hover text-end">
                                {{ move.productDepotTo?.purchasePrice ?? 0 | formatPrice }}
                              </td>
                              <td class="text-nowrap no-hover text-end">
                                {{ move.amount | number: '1.0-2' | replaceCommaToDot }}
                              </td>
                              @if (!!move.productDepotTo) {
                                <td class="text-nowrap no-hover text-end">
                                  {{ move.productDepotTo.purchasePrice * move.amount | formatPrice }}
                                </td>
                              }
                              <td>
                                @if (move.deletable && userCanDeleteProductMoves) {
                                  <btn
                                    [btnType]="'button'"
                                    [classes]="['btn-trash', 'btn-sm', 'float-right']"
                                    (onEvent)="deleteProductMove(move)"
                                    [icon]="'far-trash-alt'"
                                    [title]="'delete' | translate"
                                    data-cy="delete-row-category"
                                  ></btn>
                                }
                              </td>
                              @if (isRequiredSerialNumbers) {
                                <td>
                                  @if (move.product?.requiredSerialNumbers) {
                                    <app-modal-serial-numbers
                                      [productMove]="move"
                                      (serialNumbersEdited)="updateProductMovePack()"
                                    >
                                    </app-modal-serial-numbers>
                                  }
                                </td>
                              }
                            </tr>
                          }
                          @if (move && !move.orderItem && !!move.productDepotFrom && !move.productDepotTo) {
                            <tr>
                              @if (move.productDepotFrom.product?.id) {
                                <td class="no-hover">
                                  &nbsp;
                                  <a class="link" [routerLink]="['/product', move.productDepotFrom.product.id]"
                                    ><strong>{{ move.productDepotFrom.product.fullName }}</strong></a
                                  >
                                </td>
                              }
                              @if (!move.productDepotFrom.product) {
                                <td class="no-hover">
                                  <strong>&nbsp;</strong>
                                </td>
                              }
                              <td class="no-hover">
                                {{ move.productDepotFrom.product?.code ?? '' }}
                              </td>
                              <td class="no-hover">
                                {{ move.productDepotFrom.product?.ean ?? '' }}
                              </td>
                              <td class="no-hover">
                                {{ move.productDepotFrom.batch ?? '' }}
                              </td>
                              <td class="no-hover">
                                {{
                                  move.productDepotFrom.expirationDate?.length
                                    ? (move.productDepotFrom.expirationDate | fmtDate: 'dd.MM.yyyy')
                                    : ''
                                }}
                              </td>
                              <td class="no-hover">
                                {{ move.productDepotFrom.position?.length > 2 ? move.productDepotFrom.position : '' }}
                              </td>
                              <td class="no-hover">{{ move.productDepotFrom.product?.vat?.percent ?? 0 }}%</td>
                              <td class="text-nowrap no-hover text-end">
                                {{ move.productDepotFrom.purchasePrice ?? 0 | formatPrice }}
                              </td>
                              <td class="no-hover text-end">{{ move.amount | number: '1.0-2' | replaceCommaToDot }}</td>
                              <td class="text-nowrap no-hover text-end">
                                {{ move.productDepotFrom.purchasePrice * move.amount | formatPrice }}
                              </td>
                              <td>
                                @if (move.deletable && userCanDeleteProductMoves) {
                                  <btn
                                    [btnType]="'button'"
                                    [classes]="['btn-trash', 'btn-sm', 'float-right']"
                                    (onEvent)="deleteProductMove(move)"
                                    [icon]="'far-trash-alt'"
                                    [title]="'delete' | translate"
                                    data-cy="delete-row-category"
                                  ></btn>
                                }
                              </td>
                              @if (isRequiredSerialNumbers) {
                                <td>
                                  @if (move.product.requiredSerialNumbers) {
                                    <app-modal-serial-numbers
                                      [productMove]="move"
                                      (serialNumbersEdited)="updateProductMovePack()"
                                    >
                                    </app-modal-serial-numbers>
                                  }
                                </td>
                              }
                            </tr>
                          }
                          <!--todo: move.productDepotFrom && to // transfer-->
                          @if (move && !move.orderItem && !!move.productDepotFrom && !!move.productDepotTo) {
                            <tr>
                              @if (move.productDepotFrom.product?.id) {
                                <td class="no-hover">
                                  &nbsp;
                                  <a class="link" [routerLink]="['/product', move.productDepotFrom.product.id]"
                                    ><strong>{{ move.productDepotFrom.product.fullName }}</strong></a
                                  >
                                </td>
                              }
                              @if (!move.productDepotFrom.product) {
                                <td class="no-hover">
                                  <strong>&nbsp;</strong>
                                </td>
                              }
                              <td class="no-hover">
                                {{ move.productDepotFrom.product?.code ?? '' }}
                              </td>
                              <td class="no-hover">
                                {{ move.productDepotFrom.product?.ean ?? '' }}
                              </td>
                              <td class="no-hover">
                                @if (move.productDepotFrom.batch || move.productDepotTo.batch) {
                                  <span>
                                    {{
                                      (move.productDepotFrom.batch || '-') + ' -> ' + (move.productDepotTo.batch || '-')
                                    }}
                                  </span>
                                }
                              </td>
                              <td class="no-hover">
                                @if (move.productDepotFrom.expirationDate || move.productDepotTo.expirationDate) {
                                  <span>
                                    {{
                                      (move.productDepotFrom.expirationDate?.length
                                        ? (move.productDepotFrom.expirationDate | fmtDate: 'dd.MM.yyyy')
                                        : '-') +
                                        ' -> ' +
                                        (move.productDepotTo.expirationDate?.length
                                          ? (move.productDepotTo.expirationDate | fmtDate: 'dd.MM.yyyy')
                                          : '-')
                                    }}
                                  </span>
                                }
                              </td>
                              <td class="no-hover">
                                @if (
                                  move.productDepotFrom.position?.length > 2 || move.productDepotTo.position?.length > 2
                                ) {
                                  <span>
                                    {{
                                      (move.productDepotFrom.position?.length > 2
                                        ? move.productDepotFrom.position
                                        : '-') +
                                        ' -> ' +
                                        (move.productDepotTo.position?.length > 2 ? move.productDepotTo.position : '')
                                    }}
                                  </span>
                                }
                              </td>
                              <td class="no-hover">{{ move.productDepotFrom.product?.vat?.percent ?? 0 }}%</td>
                              <td class="text-nowrap no-hover text-end">
                                {{ move.productDepotFrom.purchasePrice || 0 | formatPrice }}
                              </td>
                              <td class="no-hover text-end">{{ move.amount | number: '1.0-2' | replaceCommaToDot }}</td>
                              <td class="text-nowrap no-hover text-end">
                                {{ move.productDepotFrom.purchasePrice * move.amount | formatPrice }}
                              </td>
                              <td>
                                @if (move.deletable && userCanDeleteProductMoves) {
                                  <btn
                                    [btnType]="'button'"
                                    [classes]="['btn-trash', 'btn-sm', 'float-right']"
                                    (onEvent)="deleteProductMove(move)"
                                    [icon]="'far-trash-alt'"
                                    [title]="'delete' | translate"
                                    data-cy="delete-row-category"
                                  ></btn>
                                }
                              </td>
                            </tr>
                          }
                          @if (move?.note?.length) {
                            <tr>
                              <td class="no-hover" colspan="8"><i [innerHtml]="move.note | nl2br"></i></td>
                            </tr>
                          }
                        </tbody>
                      }
                      <tbody>
                        <tr>
                          <td class="td-invisible border-0 no-hover" [colSpan]="6">&nbsp;</td>
                          @if (
                            productMovePack.type.id === 'in' || (productMovePack.type.id === 'out' && hasOrderItems)
                          ) {
                            <td>&nbsp;</td>
                          }
                          @if (
                            (productMovePack.type.id === 'out' && !hasOrderItems) ||
                            productMovePack.type.id === 'transfer'
                          ) {
                            <td>&nbsp;</td>
                          }
                          @if (
                            (productMovePack.type.id === 'out' && hasOrderItems) ||
                            productMovePack.type.id === 'reservation'
                          ) {
                            <td>&nbsp;</td>
                          }
                          @if (productMovePack.type.id === 'reservation') {
                            <td>&nbsp;</td>
                          }
                          <td class="border-0">
                            <b>{{ 'total' | translate }}</b>
                          </td>
                          <td class="text-end">
                            {{ getQuantitySum() | number: '1.0-2' | replaceCommaToDot }}
                          </td>
                          <td class="text-end">
                            {{ getAmountSum() | formatPrice }}
                          </td>
                          @if (isAnyOfMovesDeletable) {
                            <td class="td-invisible no-hover">&nbsp;</td>
                          }
                          @if (isRequiredSerialNumbers) {
                            <td>&nbsp;</td>
                          }
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
